import React, {useState} from 'react'
import './SearchInput.css'




function SearchInput(props) {

    const [searchText, setSearchText] = useState("")

    const onSearchingResult = (e, data) => {
        setSearchText(e.target.value)
        const filterPerson = []


        if(data){
            Object.keys(data).map(i => {
                data[i].person_data.map((person, index) => {
                    if(person.name.toLowerCase().includes(e.target.value.toLowerCase())){
                        filterPerson.push(person.name)
                    }

                    if(person.call_him.toLowerCase().includes(e.target.value.toLowerCase())){
                        filterPerson.push(person.name)
                    }

                    if(person.call_him === 'custom'){
                        if(person.custom_call_him.toLowerCase().includes(e.target.value.toLowerCase())){
                            filterPerson.push(person.name)
                        }
                    }
                })
            })
        }


        props.onFilter(filterPerson, e.target.value)
    }
  return (
    <div className='searchInput_div_searchableResult'>
        <input type='text' style={ props.width ? {width: props.width} : null} placeholder={props.placeholder} value={searchText} onChange={e => onSearchingResult(e, props.filterFrom)} />
    </div>
  )
}

export default SearchInput